import type { FunctionComponent } from 'react'
import React from 'react'
import { Spinner } from '../../Spinner'

export type LoadingOverlayProps = { children: React.ReactNode; loading: boolean; loadingComponent?: FunctionComponent }
export const LoadingOverlay = ({ children, loading, loadingComponent }: LoadingOverlayProps) => {
  const LoadingComponent = loadingComponent ?? Spinner
  return (
    <div className="position-relative">
      {children}

      {/* Loading over lay */}
      {loading && (
        <div
          style={{ zIndex: 10 }}
          className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-body bg-opacity-75"
        >
          <LoadingComponent />
        </div>
      )}
    </div>
  )
}
